import * as unionOperator from "@arcgis/core/geometry/operators/unionOperator.js";
import type { ArealplanDelområde, Teig } from "@origo/arealplan";

export const groupKeyForFeature = (
    feature: ArealplanDelområde,
    objectTypeAttributesMappings: Record<string, string[]>
): string => {
    const objtype = feature.objtype ?? '';
    const fields = objtype ? objectTypeAttributesMappings[objtype] : undefined;
    const keyField = fields && fields.length > 1 ? fields[1] : undefined;
    const keyValue = keyField
        ? feature.displayValues?.[keyField] ?? feature.attributter?.[keyField]
        : objtype;
    return (keyValue as string) || objtype || "Ukjent";
};

export const groupFeatures = (
    features: readonly ArealplanDelområde[],
    objectTypeAttributesMappings: Record<string, string[]>
): Record<string, ArealplanDelområde[]> => {
    return features.reduce((acc, f) => {
        const key = groupKeyForFeature(f, objectTypeAttributesMappings);
        if (!acc[key]) acc[key] = [];
        acc[key].push(f);
        return acc;
    }, {} as Record<string, ArealplanDelområde[]>);
};

export const mergePolygonsUnionOperator = (
    features: readonly ArealplanDelområde[]
): __esri.Polygon | null => {
    const polygons = features
        .map((f) => f.geometri)
        .filter((g): g is __esri.Polygon => !!g && g.type === "polygon");

    if (polygons.length === 0) return null;
    if (polygons.length === 1) return polygons[0];

    try {
        const merged = polygons.reduce<__esri.Polygon | null>((acc, geom) => {
            return acc ? (unionOperator.execute(acc, geom) as __esri.Polygon) : geom;
        }, null);
        return merged ?? polygons[0];
    } catch {
        return polygons[0];
    }
};

export const mergeTeigPolygons = (
    teiger: Teig[]
): __esri.Polygon | null => {
    const polygons = teiger
        .map((t) => t.geometri)
        .filter((g): g is __esri.Polygon => !!g && g.type === "polygon");

    if (polygons.length === 0) return null;
    if (polygons.length === 1) return polygons[0];

    try {
        const merged = polygons.reduce<__esri.Polygon | null>((acc, geom) => {
            return acc ? (unionOperator.execute(acc, geom) as __esri.Polygon) : geom;
        }, null);
        return merged ?? polygons[0];
    } catch {
        return polygons[0];
    }
};
